import { CountryEntity } from 'api/types/entity';
import { Stack } from 'libs/ui';
import {
  CountryRiskBadges,
  CountryRiskField,
} from 'modules/client/common/feature';
import { Maybe } from 'types/maybe';

import { renderText } from './text';

export const renderBankCountry = (country: Maybe<CountryEntity>) => (
  <Stack alignItems="center" direction="row" spacing={4}>
    {renderText(country?.name ?? '')}
    <CountryRiskBadges
      country={country}
      field={CountryRiskField.WithdrawalAccountBankCountry}
    />
  </Stack>
);
